import { FC } from 'react';
import { PayoutProviderDisplay } from '../../utils/types/Entity';
import { PayoutProviderLogoProps } from './PayoutProviderLogo.types';
import {
  PayPalColorLogo,
  PayPalWhiteLogo,
} from '../assets/svg-tsx/providerLogos';
import Typography from '../Typography/Typography';
import styles from './payout-provider-logo.module.scss';

const PayoutProviderLogo: FC<PayoutProviderLogoProps> = ({
  payoutAccountProvider,
  darkBackground = false,
  achTitleText = 'Bank Account',
}) => {
  const BankAccount = (
    <Typography variant="h5" color="midnight">
      {achTitleText}
    </Typography>
  );

  const BankAccountDarkBackground = (
    <Typography variant="h5" color="snow">
      {achTitleText}
    </Typography>
  );

  if (darkBackground) {
    return {
      [PayoutProviderDisplay.PayPal]: (
        <div className={styles.logoWrapper}>
          <PayPalWhiteLogo title="PayPalWhiteLogo" />
        </div>
      ),
      [PayoutProviderDisplay.Bank]: BankAccountDarkBackground,
    }[payoutAccountProvider];
  }

  return {
    [PayoutProviderDisplay.PayPal]: (
      <div className={styles.logoWrapper}>
        <PayPalColorLogo title="PayPalColorLogo" />
      </div>
    ),
    [PayoutProviderDisplay.Bank]: BankAccount,
  }[payoutAccountProvider];
};

export default PayoutProviderLogo;
